module.exports = __webpack_public_path__ + "assets/icons/ic_open_link_24px.svg";